import $ from 'jquery';
import { scrollToSection } from './../../components/ModelNav/modelHashNavigation';

export default class PowerReviews {

    constructor(config) {
        this.config = $.extend({
            prReviewSnippet: 'pr-reviewsnippet',
            prReviewDisplay: 'pr-reviewdisplay'
        }, config);
        this.reviewSnippet = $('#' + this.config.prReviewSnippet);
        this.reviewDisplay = $('#' + this.config.prReviewDisplay);
        this._readReviewsHandler = this._readReviewsHandler.bind(this);
        this._writeReviewHandler = this._writeReviewHandler.bind(this);
        this._submitReviewHandler = this._submitReviewHandler.bind(this);
    }

    getDefaultConfig() {
        return {
            api_key: this.config.prApiKey,
            merchant_group_id: this.config.prMerchantGroupId,
            merchant_id: this.config.prMerchantId,
            locale: 'en-US',
            page_id: this.config.prPageId,
            style_sheet: this.config.prStyleSheet,
            review_wrapper_url: this.config.prWriteReviewUrl + '?',
            on_read_reviews_click: this._readReviewsHandler,
            on_write_review_click: this._writeReviewHandler
        };
    }

    getReviewSnippetConfig() {
        return $.extend({}, this.getDefaultConfig(), {
            components: {
                ReviewSnippet: this.config.prReviewSnippet
            }
        });
    }

    getReadReviewsConfig() {
        return $.extend({}, this.getDefaultConfig(), {
            components: {
                ReviewDisplay: this.config.prReviewDisplay
            }
        });
    }

    getWriteReviewConfig() {
        return $.extend({}, this.getDefaultConfig(), {
            source: 'web',
            extra_info: {'reviewsource': 'non-harvesting'},
            campaign_id: 'non-harvesting',
            on_submit: this._submitReviewHandler,
            components: {
                Write: this.config.prReviewDisplay
            },
            on_render: (config) => {
                if (config && config.component && config.component == "WriteAReview") {
                    scrollToSection("#user-reviews");
                }
            }
        });
    }

    renderReviewSnippet() {
        if (!this.reviewSnippet.is(':empty')) {
            POWERREVIEWS.display.unmount(this.config.prReviewSnippet);
        }
        POWERREVIEWS.display.render(this.getReviewSnippetConfig());
    }

    renderReadReviews() {
        if (this.isRenderedReadReviews !== true ) {
            if (!this.reviewDisplay.is(':empty')) {
                POWERREVIEWS.display.unmount(this.config.prReviewDisplay);
            }
            POWERREVIEWS.display.render(this.getReadReviewsConfig());
            this.isRenderedReadReviews = true;
        }
    }

    renderWriteReview() {
        if (this.isRenderedReadReviews !== false ) {
            if (!this.reviewDisplay.is(':empty')) {
                POWERREVIEWS.display.unmount(this.config.prReviewDisplay);
            }
            POWERREVIEWS.display.render(this.getWriteReviewConfig());
            this.isRenderedReadReviews = false;
        }
    }

    _readReviewsHandler() {
        if ($.isFunction(this.config.prOnReadReviewsClick)) {
            this.config.prOnReadReviewsClick();
        }
        this.renderReadReviews();
    }

    _writeReviewHandler() {
        if ($.isFunction(this.config.prOnWriteReviewClick)) {
            this.config.prOnWriteReviewClick();
        }
        this.renderWriteReview();
    }

    _submitReviewHandler() {
        if ($.isFunction(this.config.prOnSubmit)) {
            this.config.prOnSubmit();
        }
    }

}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/shared/PowerReviews/index.js